export default __webpack_public_path__ + "static/media/down-arrow.c6d59462.svg";